import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessengerService } from '@services/messenger/messenger.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { StorageService } from '@services/storage/storage.service';

@Component({
    selector: 'app-reset',
    templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.scss'],
    standalone: false
})
export class ResetComponent implements OnInit {

  email: string;
  resetAccountID: string;
  resetToken: string;
  password: string = null;
  type: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ms: MessengerService,
    private snackbar: SnackbarService,
    private storage: StorageService,
  ) {
  }

  ngOnInit() {
    const data = this.ms.getResetPasswordData();

    if (data) {
      this.email = data.loginName;
      this.resetAccountID = data.AccountID;
      this.resetToken = data.accessToken;
      this.type = data.type
    }
  }

  navigateToLogin() {
    this.router.navigate([{ outlets: { 'authentication': ['login'] } }], { relativeTo: this.route.parent });
  }

  onPasswordValidatiton(password) {
    this.password = password;
  }

  resetPassword() {
    this.ms.validateResetToken(this.resetToken).then(() => {
      this.ms.resetPasswordWithToken(this.email, this.password, this.resetAccountID, this.type).then(result => {
        if (result.data.success) {
          this.ms.loginWithEmailPasswordCredential(this.email, this.password).then(login => {
            this.snackbar.open('New password set: ' + this.password, 5000);
            if (login && login.level) {
              this.storage.get('rememberToken').then(storageResult => {
                if (storageResult) {
                  this.storage.remove('rememberToken');
                }
                this.ms.createDeviceIdTokenCredential();
              });
            }
          });
        } else {
          this.snackbar.error('Could not set new password');
        }
      }, err => {
        console.log(err);
        this.snackbar.error('Error: Could not set new password');
      });
    }, err => {
      console.log(err);
      this.router.navigateByUrl('(auth:auth/(authentication:message))?messagetype=invalidToken', { replaceUrl: true });
    });

  }

}
